module.exports = __webpack_public_path__ + "img/logo.4f34a781.png";